import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Inject,
  InjectionToken,
  OnInit,
} from '@angular/core';
import { UrlUtilsService } from '@rd/core/services/url-utils/url-utils.service';

export const SPINNER_URL_TOKEN = new InjectionToken<string>(
  'SPINNER_URL_TOKEN',
  {
    factory: () => '/images/rd/processing-loading.svg',
  },
);

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'rd-shared-spinner',
  template: `<img
    class="spinner-image"
    [src]="spinnerUrl"
    alt="Loading in progress" /> `,
  styleUrls: ['./spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RdSpinnerComponent implements OnInit {
  @HostBinding('class.rd-shared-spinner') componentClass = true;

  spinnerUrl: string;

  constructor(
    protected urlUtilsService: UrlUtilsService,
    @Inject(SPINNER_URL_TOKEN) private imageUrl: string,
  ) {}

  ngOnInit(): void {
    this.spinnerUrl = this.urlUtilsService.imageUrl(this.imageUrl);
  }
}
